import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import { DRNSnackbar } from '@traveloka/district-ui';

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'flex-end',
  },
});

class SnackbarAutoClose extends Component {
  static propTypes = {
    duration: PropTypes.number,
  };

  static defaultProps = {
    duration: 2500,
  };

  state = {
    visible: true,
  };

  componentDidMount() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(this.hideSnackbar, this.props.duration);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  hideSnackbar = () => {
    this.setState({ visible: false });
  };

  render() {
    if (!this.state.visible) return null;

    return (
      <View style={styles.container}>
        <DRNSnackbar {...this.props} actionOnPress={this.hideSnackbar} />
      </View>
    );
  }
}

export default SnackbarAutoClose;
